import React from 'react';
import { Icon } from './Icon.js';
export const IconRadioUnchecked = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("circle", { cx: "10", cy: "10", r: "7", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconRadioUnchecked.js.map